import { slotList } from "@/Util/manifest";

export default {
  Page: {
    title: "Stranica",
    plural: "Stranice",
    labelNew: "Nova stranica",
    hasDeleted: true,
    hasVariants: true,
    columns: slotList([
      {
        name: "slug",
        label: "Deo URL-a",
        default: true,
          searchComponent: "SearchText",
      },
      {
        name: "title",
        label: "Naziv",
        default: true,
          searchComponent: "SearchText",
          //         childToggle: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Main",
        groups: slotList([
          {
            cols: 12,
            fields: slotList([
              {
                id: "title", priority: 0,
                label: "Naziv",
                cols: 12,
              },
              {
                id: "slug", priority: 0,
                label: "Deo url-a",
                cols: 4,
                component: "FormPageSlug",
              },
              // {
              //   id: "template", priority: 0,
              //   label: "Poseban templejt",
              //   cols: 4,
              //   component: "FormPageTemplate",
              // },
              // {
              //   id: "icon", priority: 0,
              //   label: "Ikonica u meniju",
              //   cols: 4,
              //   enum: [ "home", "info", "industry", "infra", "media", "history" ],
              // },
              {
                id: "photo", priority: 0,
                label: "Slika",
                cols: 8,
              },
              // {
              //   id: "intro", priority: 0,
              //   label: "Tekst u listi",
              //   type: "wysiwyg",
              //   cols: 12,
              // },

              //               {
              //                 id: "blockGroup", priority: 0,
              //                 label: "Content",
              //                 cols: 12,
              //               },
              {
                id: "pageBlockGroup", priority: 0,
                label: "Blocks",
                cols: 12,
              },
            ]),
          },
        ]),
      },
      {
        cols: 12,
        id: "seo", priority: 0,
        title: "SEO",
        groups: slotList([
          {
            cols: 12,
            fields: slotList([
              {
                id: "htmlTitle", priority: 0,
                label: "HTML Title",
                cols: 12,
              },
              {
                id: "htmlDescription", priority: 0,
                label: "HTML Description",
                cols: 12,
              },
              {
                id: "photo", priority: 0,
                label: "Main Photo",
                cols: 12,
              },
            ]),
          },
        ]),
      },
    ]),
  },
  Menu: {
    title: "Meniji",
    plural: "Meniji",
    labelNew: "Nov meni",
    hasDeleted: true,
    hasVariants: true,
    columns: slotList([
      {
        name: "title",
        label: "Naziv",
        default: true,
          searchComponent: "SearchText",
          //         childToggle: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Main",
        groups: slotList([
          {
            cols: 12,
            fields: slotList([
              {
                id: "title", priority: 0,
                label: "Naziv",
                cols: 6,
              },
              {
                id: "slug", priority: 0,
                label: "ID menija",
                cols: 6,
              },
            ]),
          },
          {
            cols: 12,
            fields: slotList([
              {
                id: "items", priority: 0,
                label: "Stavke",
                cols: 12,
              },
            ]),
          },
        ]),
      },
    ]),
  },
  MenuItem: {
    title: "Stavke menija",
    plural: "Stavke menija",
    labelNew: "Nova stavka",
    hasDeleted: true,
    hasVariants: true,
    columns: slotList([
      {
        name: "title",
        label: "Naziv",
        default: true,
          searchComponent: "SearchText",
          //         childToggle: true,
      },
    ]),
    form: slotList([
      {
        cols: 12,
        id: "basic", priority: 0,
        title: "Main",
        groups: slotList([
          {
            cols: 12,
            fields: slotList([
              {
                id: "title", priority: 0,
                label: "Naziv",
                cols: 4,
              },
              {
                id: "target", priority: 0,
                label: "Link",
                cols: 4,
              },
              {
                id: "photo", priority: 0,
                label: "Photo",
                cols: 4,
              },
              {
                id: "children", priority: 0,
                label: "",
                cols: 12,
              },
            ]),
          },
        ]),
      },
    ]),
  },
  PageBlockGroup: { // TODO
    title: "Page block group",
    plural: "Page block groups",
    labelNew: "New group",
    columns: slotList([
    ]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: "blocks", priority: 0,
            label: "",
            cols: 12,
          },
        ]),
      },
    ]),
  },
  // PageBlock: {
  //   title: "Content block",
  //   plural: "Content blocks",
  //   labelNew: "New content block",
  //   hasDeleted: true,
  //   columns: slotList([
  //   ]),
  //   form: slotList([
  //     {
  //       id: "basic", priority: 0,
  //       fields: slotList([
  //         {
  //           id: "type", priority: 0,
  //           label: "Type",
  //           cols: 12,
  //         },
  //         {
  //           id: "content", priority: 0,
  //           label: "Content",
  //           cols: 12, // TODO
  //         },
  //       ]),
  //     },
  //   ]),
  // },
  PageBlockText: {
    pageBlockTitle: "Text content",
    columns: slotList([]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: "content", priority: 0,
            // label: "Content",
            cols: 12,
            type: "relMany",
            dbfield: {
              target: "Block",
              skip: ["blockGroup"],
              cascade: "delete",
            }
          },
        ]),
      },
    ]),
  },
  BlockGroup: {
    title: "Sadržaj",
    plural: "Sadržaji",
    labelNew: "Nov sadržaj",
    hasDeleted: true,
    columns: slotList([
//       {
//         name: "title",
//         label: "Naziv",
//         default: true,
//         searchComponent: "SearchText",
//       },
    ]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: "blocks", priority: 0,
            label: "",
            cols: 12,
          },
        ]),
      },
    ]),
  },
  Block: {
    title: "Blok sadržaja",
    plural: "Blokovi sadržaja",
    labelNew: "Nov blok sadržaja",
    hasDeleted: true,
    columns: slotList([
    ]),
    form: slotList([
      {
        id: "basic", priority: 0,
        fields: slotList([
          {
            id: "type", priority: 0,
            label: "Vrsta",
            cols: 12,
          },
          {
            id: "content", priority: 0,
            label: "Sadržaj",
            cols: 12, // TODO
          },
        ]),
      },
    ]),
  },
}
